import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import ConstraintOverview from './constraint-overview/constraint-overview';

const ConstraintCreate = lazy(() => import('./constraint-create/constraint-create.component'));
const ConstraintUpdate = lazy(() => import('./constraint-update/constraint-update.component'));

export function ConstraintRoutes() {
    return (
        <Route path='constraints'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ConstraintOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <ConstraintCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':constraintId'>
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ConstraintUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
